import moment from 'moment';
import MomentUtils from '@date-io/moment';
import 'moment/locale/es';

import React, { useState, Fragment } from 'react';
import {
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Typography,
} from '@material-ui/core';
import { MuiPickersUtilsProvider, DatePicker, TimePicker } from '@material-ui/pickers';

import useStyles from './styles';
import validarHoraRango from '../../../helpers/validarRangoHorario';

import { constants } from '../../../config';

moment.locale('es');

export default function MaterialUIPickers({
  fieldSelected,
  setDataSearchServicio,
  vuelta,
}) {
  const [horaFueraDeRango, sethoraFueraDeRango] = useState(null);

  const classes = useStyles();
  const [locale] = useState('es');

  const [horaComponent, setHoraComponent] = useState(fieldSelected.hora);
  const [fechaComponent, setFechaComponent] = useState(fieldSelected.fecha);

  const handleDateChange = (date) => {
    setDataSearchServicio({ target: { name: 'fecha', value: date } });
    setFechaComponent(date);
  };

  const handleTimeChange = (time) => {
    // validarHoraRango(time)
    //   ? setDataSearchServicio({ target: { name: 'hora', value: time } })
    //   : setDataSearchServicio({ target: { name: 'hora', value: '' } });
    setDataSearchServicio({ target: { name: 'hora', value: time } });
    setHoraComponent(time);
  };

  const disableWeekends = (date) => {
    return moment(date).isoWeekday() === 6 || moment(date).isoWeekday() === 7;
  };

  // useEffect(() => {
  //   if (validarHoraRango(horaComponent)) {
  //     setDataSearchServicio({ target: { name: 'hora', value: horaComponent } });
  //     sethoraFueraDeRango('');
  //   } else {
  //     setDataSearchServicio({ target: { name: 'hora', value: '' } });
  //     sethoraFueraDeRango(
  //       <span style={{ color: 'red' }}>
  //         Solo para servicios entre las 6 y las 10 de la mañana.
  //       </span>
  //     );
  //   }
  // }, [fechaComponent, horaComponent]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Fragment>
      <Typography variant='h6'> Seleccioná el día y la hora</Typography>
      <FormControl component='div'>
        <FormLabel component='legend'>Horario aproximado según :</FormLabel>
        <RadioGroup
          row
          aria-label='gender'
          name='horarioAprox'
          value={fieldSelected.horarioAprox}
          onChange={setDataSearchServicio}
        >
          <FormControlLabel
            value={'salida'}
            control={<Radio />}
            label='Salida de Estación Origen'
          />
          <FormControlLabel
            value={'llegada'}
            control={<Radio />}
            label='Llegada a Estación Destino'
          />
        </RadioGroup>
      </FormControl>
      <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={locale}>
        <Grid container spacing={3}>
          {!vuelta && (
            <Grid item xs={12} sm={6}>
              <DatePicker
                className={classes.formControl}
                margin='normal'
                id='date-picker-dialog'
                label='Seleccione el dia'
                cancelLabel='Cancelar'
                clearLabel='Limpiar'
                okLabel='Aceptar'
                format='DD/MM/yyyy'
                minDate={moment().toDate()}
                maxDate={moment().add(constants.dias_adelante_seleccion, 'days').toDate()}
                value={fechaComponent}
                onChange={handleDateChange}
                //shouldDisableDate={disableWeekends}
                maxDateMessage={'La fecha es mayor al maximo determinado'}
                minDateMessage={'La fecha es menor al minimo determinado'}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={vuelta ? 12 : 6}>
            <TimePicker
              className={classes.formControl}
              clearable
              ampm={false}
              margin='normal'
              id='time-picker'
              label='Hora aproximada'
              cancelLabel='Cancelar'
              clearLabel='Limpiar'
              okLabel='Aceptar'
              value={horaComponent ? horaComponent : Date.now()}
              onChange={handleTimeChange}
            />
            {horaFueraDeRango}
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </Fragment>
  );
}
